import Container from '@/components/base/Container';
import ClosingLink from '@/components/base/ClosingLink';

export default function ServicesClosing() {
  return (
    <section aria-labelledby="services-closing" className="bg-white pb-12 pt-16 md:pb-16 md:pt-20">
      <Container>
        <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-8 border-t border-[#E6E6E6] pt-12 md:pt-16 lg:grid-cols-12 lg:gap-x-14">
          <div className="lg:col-span-6">
            <p className="text-[12px] font-medium uppercase tracking-[0.12em] text-[#7A7A7A]">COMMON / SERVICES</p>
            <h2 id="services-closing" className="mt-5 font-heading text-[30px] font-semibold leading-[1.15] tracking-[-0.01em] text-[#222222] md:text-[36px] lg:text-[42px]">
              Good service is in the details.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:border-l lg:border-[#E6E6E6] lg:pl-14 lg:pt-10">
            <p className="max-w-[460px] text-[16px] leading-[1.6] text-[#5F5F5F]">
              From routine maintenance to resident support, we&apos;re here to help communities run smoothly.
            </p>
            <div className="mt-8">
              <ClosingLink to="/contact?type=partnership" label="Request a Proposal" />
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}